import React from 'react';

export default function Reported() {
  return (
    <div className="reported">
      Nahlášení problému s rezervací bylo odesláno, co nejdříve se Vám ozveme.
    </div>
  );
}
